<template>
  <div>
    <message :messages="messages"></message>
    <v-card>
      <v-toolbar color="grey darken-1" dark>
        <v-toolbar-title>
          <v-icon large>{{motorIcon}}</v-icon>
          Motor Summary
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items class="hidden-md-and-down">
          <v-btn flat @click="printQuote" v-if="canPrintQuote" :loading="printQuoteLoading">
            Print Quote
            <v-icon right>mdi-printer</v-icon>
          </v-btn>
          <v-btn flat @click="printCoverNote" v-if="canPrintCoverNote" :loading="printCNLoading">
            Print Cover Note
            <v-icon right>mdi-printer</v-icon>
          </v-btn>
          <v-btn flat @click="openUpdate" v-if="canUpdateIFDetails">
            Update Details
            <v-icon right>mdi-content-save</v-icon>
          </v-btn>
          <v-btn flat @click="showComm = true">
            Communication
            <v-icon right>mdi-comment-text</v-icon>
          </v-btn>
        </v-toolbar-items>
        <v-btn icon class="hidden-lg-and-up">
          <v-menu bottom left>
            <v-btn slot="activator" icon>
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
            <v-list>
              <v-list-tile @click="printQuote" v-if="canPrintQuote">
                <v-list-tile-title>Print Quote</v-list-tile-title>
              </v-list-tile>
              <v-list-tile @click="printCoverNote" v-if="canPrintCoverNote">
                <v-list-tile-title>Print Cover Note</v-list-tile-title>
              </v-list-tile>
              <v-list-tile @click="showUpdate = true">
                <v-list-tile-title>Update Details</v-list-tile-title>
              </v-list-tile>
              <v-list-tile @click="showComm = true">
                <v-list-tile-title>Communication</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
        </v-btn>
      </v-toolbar>
      <v-divider></v-divider>
      <v-card-text>
        <v-container fluid grid-list-lg>
          <v-layout row wrap>
            <v-flex lg6 xs12>
              <v-container fluid grid-list-lg>
                <v-layout row wrap>
                  <v-flex xs6>
                    <v-subheader class="queryLabel">Quotation No.</v-subheader>
                  </v-flex>
                  <v-flex xs6>
                    <span class="title">{{commonForm.proposalNo}}</span>
                  </v-flex>
                  <template v-if="renderPremium">
                    <v-flex xs6>
                      <v-subheader class="queryLabel">Premium Payable</v-subheader>
                    </v-flex>
                    <v-flex xs6>
                      <span class="title">{{currPrefix}}{{formatDisplayNumber(commonInfo.premium.premiumPayable)}}</span>
                    </v-flex>
                  </template>
                  <v-flex xs6>
                    <v-subheader class="queryLabel">Current Status</v-subheader>
                  </v-flex>
                  <v-flex xs6>
                    <span :class="currentStatusClass">{{currentStatusLabel}}</span>
                  </v-flex>
                  <v-flex xs6>
                    <v-subheader class="queryLabel">Intermediary</v-subheader>
                  </v-flex>
                  <v-flex xs6>
                    <span>{{commonForm.intermediary}} - {{queryInfo.intermediary}}</span>
                  </v-flex>
                  <template v-if="commonForm.product">
                    <v-flex xs6>
                      <v-subheader class="queryLabel">Product</v-subheader>
                    </v-flex>
                    <v-flex xs6>
                      <span>{{commonForm.product}} - {{queryInfo.product}}</span>
                    </v-flex>
                  </template>
                  <template v-if="motorForm.busCls">
                    <v-flex xs6>
                      <v-subheader class="queryLabel">Business Class</v-subheader>
                    </v-flex>
                    <v-flex xs6>
                      <span>{{motorForm.busCls}} - {{queryInfo.busCls}}</span>
                    </v-flex>
                  </template>
                  <template v-if="motorForm.tariff">
                    <v-flex xs6>
                      <v-subheader class="queryLabel">Tariff</v-subheader>
                    </v-flex>
                    <v-flex xs6>
                      <span>{{motorForm.tariff}} - {{queryInfo.tariff}}</span>
                    </v-flex>
                  </template>
                  <template v-if="motorForm.cover">
                    <v-flex xs6>
                      <v-subheader class="queryLabel">Type of Cover</v-subheader>
                    </v-flex>
                    <v-flex xs6>
                      <span>{{motorForm.cover}} - {{queryInfo.cover}}</span>
                    </v-flex>
                  </template>
                  <template v-if="commonForm.acceptDate">
                    <v-flex xs6>
                      <v-subheader class="queryLabel">Acceptance Date</v-subheader>
                    </v-flex>
                    <v-flex xs6>
                      <span>{{formatDisplayDateTime2(commonForm.acceptDate)}}</span>
                    </v-flex>
                  </template>
                  <template v-if="commonForm.startDate">
                    <v-flex xs6>
                      <v-subheader class="queryLabel">Start Date</v-subheader>
                    </v-flex>
                    <v-flex xs6>
                      <span>{{formatDate(commonForm.startDate)}}</span>
                    </v-flex>
                  </template>
                  <template v-if="commonForm.endDate">
                    <v-flex xs6>
                      <v-subheader class="queryLabel">End Date</v-subheader>
                    </v-flex>
                    <v-flex xs6>
                      <span>{{formatDate(commonForm.endDate)}}</span>
                    </v-flex>
                  </template>
                  <template v-if="commonForm.campaign">
                    <v-flex xs6>
                      <v-subheader class="queryLabel">Campaign</v-subheader>
                    </v-flex>
                    <v-flex xs6>
                      <span>{{commonForm.campaign}} - {{queryInfo.campaign}}</span>
                    </v-flex>
                  </template>
                  <template v-if="commonForm.promotion">
                    <v-flex xs6>
                      <v-subheader class="queryLabel">Promotion</v-subheader>
                    </v-flex>
                    <v-flex xs6>
                      <span>{{commonForm.promotion}} - {{queryInfo.promotion}}</span>
                    </v-flex>
                  </template>
                </v-layout>
              </v-container>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
    <v-dialog v-model="showComm" width="600px">
      <comms-log :canSendSMS="checkAccess(['motorQuoteIFSMS'])" :canSendEmail="checkAccess(['motorQuoteIFMail'])" @close="showComm = false"></comms-log>
    </v-dialog>
    <v-dialog v-model="showUpdate" width="500px" persistent>
      <v-card>
        <v-card-title class="headline">
          <div class="headline">
            Update Details
          </div>
          <v-spacer></v-spacer>
          <v-btn flat icon @click="showUpdate = false" v-if="!updateLoading">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-container fluid grid-list-lg>
            <v-layout row wrap>
              <v-flex xs12>
                <v-text-field v-model="updateForm.vehRegNo" v-uppercase="updateForm.vehRegNo" label="Registration No.*" :error-messages="errors.collect('vehRegNo')" data-vv-name="vehRegNo" data-vv-as="Registration No." v-validate="'required|veh_reg_no|max:8'"></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" flat="flat" @click.native="showUpdate = false" v-if="!updateLoading">Cancel</v-btn>
          <v-btn color="primary" flat="flat" @click.native="doUpdate" :loading="updateLoading">Update</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { formatDisplayDate, formatDisplayDateTime2 } from '@/utils/date'
import { formatDisplayNumber } from '@/utils/number'
import { quoteStatus, appIcon } from '@/const/underwriting'
import MessageMixin from '@/mixins/message'
import { mapGetters } from 'vuex'
import CommsLog from '../../shared/CommsLog'

export default {
  data() {
    return {
      printQuoteLoading: false,
      printCNLoading: false,
      showComm: false,
      showUpdate: false,
      updateLoading: false,
      updateForm: {
        vehRegNo: null
      }
    }
  },
  computed: {
    ...mapGetters([
      'checkAccess'
    ]),
    quotation() {
      return this.$store.state.agency.quotation
    },
    currPrefix() {
      return this.$store.state.agency.quotation.commonInfo.currPrefix
    },
    currentStatusLabel() {
      if (quoteStatus[this.quotation.commonInfo.statusCode]) {
        return quoteStatus[this.quotation.commonInfo.statusCode]
      } else {
        return 'Unknown Status'
      }
    },
    currentStatusClass() {
      if (this.quotation.commonInfo.statusCode === 'QD' || this.quotation.commonInfo.statusCode === 'PD' || this.quotation.commonInfo.statusCode === 'VO' || this.quotation.commonInfo.statusCode === 'NTU' || this.quotation.commonInfo.statusCode === 'CL') {
        return 'error--text'
      } else if (this.quotation.commonInfo.statusCode === 'QPA' || this.quotation.commonInfo.statusCode === 'PPA') {
        return 'warning--text'
      } else if (this.quotation.commonInfo.statusCode === 'IF' || this.quotation.commonInfo.statusCode === 'PO') {
        return 'success--text'
      } else {
        return ''
      }
    },
    renderPremium() {
      if (this.quotation.commonInfo.premium.premiumPayable && this.quotation.commonInfo.premium.premiumPayable > 0) {
        if (this.quotation.commonInfo.statusCode === 'NQ' || this.quotation.commonInfo.statusCode === 'QPA') {
          if (this.quotePermitStatus.permitStatus === 'A') {
            return true
          } else if (this.quotePermitStatus.permitStatus === 'R') {
            // Only allow if user has permit acccess
            if (this.checkAccess(['motorQuoteRef', 'motorQuoteSTP'])) {
              return true
            }
          }
        } else {
          return true
        }
      }
      return false
    },
    quotePermitStatus() {
      return this.$store.getters.mtrQuoteQueryPermitStatus
    },
    motorForm() {
      return this.quotation.motorForm
    },
    commonForm() {
      return this.quotation.commonForm
    },
    commonInfo() {
      return this.quotation.commonInfo
    },
    queryInfo() {
      return this.quotation.queryInfo
    },
    canPrintQuote() {
      if (this.checkAccess(['motorPrintQuote'])) {
        if (this.$store.state.agency.quotationSettings.menu.printQuote) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    },
    canPrintCoverNote() {
      if (this.checkAccess(['motorPrintCN'])) {
        if (this.$store.state.agency.quotationSettings.menu.printCN) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    },
    canUpdateIFDetails() {
      if (this.checkAccess(['motorQuoteUpdateDetails'])) {
        if (this.$store.state.agency.quotationSettings.menu.updateDetails) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    },
    motorIcon() {
      return appIcon.MOTOR
    }
  },
  methods: {
    formatDate(date) {
      return formatDisplayDate(date)
    },
    formatDisplayDateTime2(date) {
      return formatDisplayDateTime2(date)
    },
    async printQuote() {
      const apiUrl = this.$store.state.agency.quotationSettings.menu.printQuote
      if (apiUrl) {
        try {
          this.printQuoteLoading = true
          const passObj = {
            proposalNo: this.commonForm.proposalNo
          }
          await this.$http.post(apiUrl, passObj)
          this.printQuoteLoading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.fullMessage(data)
          }
          this.printQuoteLoading = false
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    async printCoverNote() {
      const apiUrl = this.$store.state.agency.quotationSettings.menu.printCN
      if (apiUrl) {
        try {
          this.printCNLoading = true
          const passObj = {
            proposalNo: this.commonForm.proposalNo
          }
          await this.$http.post(apiUrl, passObj)
          this.printCNLoading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.fullMessage(data)
          }
          this.printCNLoading = false
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    openUpdate() {
      // Default values
      this.updateForm.vehRegNo = this.motorForm.vehRegNo

      this.showUpdate = true
    },
    doUpdate() {
      this.$validator.validateAll().then(result => {
        if (result) {
          const apiUrl = this.$store.state.agency.quotationSettings.menu.updateDetails
          if (apiUrl) {
            this.updateLoading = true

            const submitForm = {
              proposalNo: this.commonForm.proposalNo,
              revision: this.commonForm.revision,
              vehRegNo: this.updateForm.vehRegNo
            }
            this.$http.post(apiUrl, submitForm)
              .then(result => {
                if (result.data) {
                  this.message(result.data)
                }
                this.updateLoading = false
                this.showUpdate = false
                this.$emit('init')
              })
              .catch(err => {
                const { data } = err.response
                if (data) {
                  this.message(data)
                  this.updateLoading = false
                  this.showUpdate = false
                }
              })
          } else {
            this.errorMessage('Invalid API URL')
            this.showUpdate = false
          }
        }
      })
    },
    formatDisplayNumber(xNum) {
      return formatDisplayNumber(xNum)
    }
  },
  mounted() {
    // If Query param (if) is passed in, its coming from Inforced Proposal
    // Check comms log
    if (this.$route.query.if) {
      if (this.checkAccess(['motorQuoteIFSMS']) || this.checkAccess(['motorQuoteIFMail'])) {
        this.showComm = true
      }
    }
  },
  mixins: [
    MessageMixin
  ],
  components: {
    CommsLog
  }
}
</script>

<style lang="scss">
</style>
